import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { belongsTo } from 'ember-data/relationships';
import PlanModel from 'cio/models/plan';
import moment from 'moment-timezone';
import { ONE_WEEK_IN_SECONDS } from 'cio/utils/time-constants';
import { StripeCustomer } from 'cio/utils/billing/stripe-customer';

export default class SubscriptionModel extends Model {
  @belongsTo('plan', { async: false, inverse: null }) plan!: PlanModel;
  @attr('boolean') active!: boolean;
  @attr('boolean') annual!: boolean;
  @attr('number') periodStart!: number;
  @attr('number') periodEnd!: number;
  @attr('number') couponEndsAt!: number;
  @attr('boolean') hasAchSetup!: boolean;
  @attr('boolean') hasFailedOverageCharge!: boolean;
  @attr('camel-case') stripeCustomer!: StripeCustomer;

  get hasCard() {
    return !!this.stripeCustomer?.cardType;
  }

  get nextBillingWithinAWeek() {
    return this.periodEnd < moment().unix() + ONE_WEEK_IN_SECONDS;
  }

  get daysRemainingInPeriod() {
    return moment.unix(this.periodEnd).diff(moment(), 'days');
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    subscription: SubscriptionModel;
  }
}
